import type { LOCAL_STORAGE_KEYS } from 'ts/constants/local-storage-keys';

type LocalStorageKey = (typeof LOCAL_STORAGE_KEYS)[keyof typeof LOCAL_STORAGE_KEYS];

export const getJsonFromStorage = (key: LocalStorageKey) => {
  try {
    const data = localStorage.getItem(key);
    if (data) return JSON.parse(data);
    return null;
  } catch {
    return null;
  }
};
